module.exports = __webpack_public_path__ + "media/images/common/menu_shoes_ov-d6ca9465b7a758836e72463557eac826.gif";